import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Feedback from './Feedback';
import MessengerChat from '../messenger/v2/MessengerChat';
import Loading from './Loading';
import { ajaxScrollFilterChat, setSelectedFeedback } from '../redux/FeedbackRedux';
import * as uuid from 'uuid';

class ChatList extends React.Component {

	constructor() {
		super();
		this.state = { width: null, height: null, element_id: uuid.v4() };
		this.updateDimensions = this.updateDimensions.bind(this);

	}

	handleScroll(event) {
		if (jQuery(event.target).scrollTop() + jQuery(event.target).innerHeight() >= event.target.scrollHeight) {
			var timeframe = this.props.state.timeframe;
			var status = this.props.state.status;
			var fid = this.props.state.feedback_detail.feedback_id;
			var page = this.props.state.current_page + 1;
			if (page <= this.props.state.total_pages) {
				if (!this.props.state.businesses) {
					var bid = this.props.state.business.business_id;
					if (this.props.state.loading == false) {
						this.props.dispatch(ajaxScrollFilterChat(timeframe, status, fid, bid, page, this.props.state.total_pages, this.props.state.other_filter, this.props.state.archive));
					}
				} else {
					var ids = [];
					for (var i in this.props.state.businesses) {
						ids.push(this.props.state.businesses[i].business_id);
					}
					if (this.props.state.loading == false) {
						this.props.dispatch(ajaxScrollFilterChat(timeframe, status, fid, ids, page, this.props.state.total_pages, this.props.state.other_filter, this.props.state.archive));

					}
				}
			}
		}
	}



	render() {
		var items = [];
		this.props.state.initial_feedbacks.map((value, index) => {
			items.push(<MessengerChat key={index} feedback={value} id={value.feedback_id} />);
		});

		return (
			<div className="feedback-list scroll" id={this.state.element_id}>
				<div className="w-100" onScroll={this.handleScroll.bind(this)} style={{ "width": this.state.width + "px" }} >
					<Loading location={'search'} />
					{items}
					<div className="col-sm-12 pt-3 pb-3 text-center">
						<Loading location={'list'} />
					</div>
				</div>
			</div>
		);
	}


	updateDimensions() {
		var element = document.getElementById(this.state.element_id);

		var elementWidth = parseFloat(element.clientWidth);

		var cs = getComputedStyle(element);



		var new_width = elementWidth;

		this.setState({ width: new_width });
	}

	componentDidMount() {
		this.updateDimensions();
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}
}

function mapStateToProps(state) {
	return { state: state }
}

export default connect(mapStateToProps)(ChatList)